<template>
  <v-container grid-list-md>
    <v-layout row wrap v-if="items !== null">
      <v-flex>
        <silentbox-group>
          <v-layout row wrap>
            <v-flex xs6 v-for="(thumb, index) in items" :key="index">
              <silentbox-item
                :src="'data:image/png;base64,' + thumb.optimizationImage"
                :description="thumb.optimizationImageAlt"
              >
                <span>{{thumb.flatCount}}x</span>
                <v-img :src="images.demosImageUrl(thumb)" aspect-ratio="5"></v-img>
                <v-img
                  :key="index"
                  :src="'data:image/png;base64,' + thumb.optimizationImage"
                  width="100%"
                  min-width="100%"
                  :alt="thumb.optimizationImageAlt"
                  :title="thumb.optimizationImageAlt"
                />
              </silentbox-item>
            </v-flex>
          </v-layout>
        </silentbox-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <span>{{empty}}</span>
    </v-layout>
  </v-container>
</template>

<script>
import images from "@/views/cutting/js/images";
export default {
  name: "Gallery",
  props: {
    optimizationResultItems: Object,
    empty: {
      default: "no data",
      type: String
    }
  },
  data() {
    return {
      images: images
    };
  },
  computed: {
    items() {
      if (
        this.optimizationResultItems !== undefined &&
        this.optimizationResultItems.optimizationItems !== undefined &&
        this.optimizationResultItems.optimizationItems.length > 0
      ) {
        return this.optimizationResultItems.optimizationItems;
      }

      return null;
    }
  }
};
</script>